import React from "react";
import Flex from "../Flex";
import Spinner from "../Spinner";
import SpectralLogo from "../../assets/spectral.svg";
import * as SC from "./ScoreLoader.styles";
import ShuffleText from "../ShuffleText";
import { SCORE_CALCULATE_DESCRIPTION } from "./constants";

export const ScoreLoader = () => {
  return (
    <SC.ScoreLoaderContainer>
      <Flex width="100%" align="center" justify="between" column>
        <img src={SpectralLogo} alt="Spectral Logo" />
        <h1>
          Our machine learning
          <br /> model is working for you
        </h1>

        <SC.Divider />

        <Spinner size="m" />

        <ShuffleText text={SCORE_CALCULATE_DESCRIPTION} />
      </Flex>
    </SC.ScoreLoaderContainer>
  );
};
